const ApproveIcon = ({
  bgColor,
  iconColor,
  height = "40px",
  width = "40px",
}: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_590_5144)">
        <path
          d="M32.5 40H7.5C3.3575 40 0 36.6425 0 32.5V7.5C0 3.3575 3.3575 0 7.5 0H32.5C36.6425 0 40 3.3575 40 7.5V32.5C40 36.6425 36.6425 40 32.5 40Z"
          fill={bgColor}
        />
        <path
          d="M20 10C14.4863 10 10 14.4863 10 20C10 25.5138 14.4863 30 20 30C25.5138 30 30 25.5138 30 20C30 14.4863 25.5138 10 20 10ZM25.0688 17.8813L19.6525 23.2975C19.49 23.46 19.2763 23.5413 19.0638 23.5413C18.85 23.5413 18.6375 23.46 18.475 23.2975L15.7662 20.5888C15.4412 20.2638 15.4412 19.7362 15.7662 19.41C16.0912 19.0837 16.6187 19.085 16.945 19.41L19.0638 21.5287L23.8913 16.7013C24.2163 16.3763 24.7437 16.3763 25.07 16.7013C25.3962 17.0262 25.3938 17.555 25.0688 17.8813Z"
          fill={iconColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_590_5144">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ApproveIcon;
